$(function () {
	function changeFieldState(id, checked) {
		window.pushpay.enableField('[data-toggler-action-enable~="' + id + '"]');

		window.pushpay.disableThenClearIfVisible('[data-toggler-action-disable~="' + id + '"]');

		$('[data-toggler-action-state~="' + id + '"]').each(function() {
			if (checked) {
				window.pushpay.enableField(this);
			} else {
				window.pushpay.disableThenClearIfVisible(this);
			}
		});

		$('[data-toggler-action-check~="' + id + '"]').each(function () {
			$(this).click();
		});
	}

	$('input[data-toggler-notify]:radio, input[data-toggler-notify]:checkbox').each(function () {
		var $this = $(this);
		// Initialise checkboxes and checked radio buttons
		if ($this.is(':checkbox') || $this.prop('checked')) {
			changeFieldState($(this).attr('id'), $(this).prop('checked'));
		}
	});

	$('form').on("change", 'input[data-toggler-notify]:radio, input[data-toggler-notify]:checkbox', function () {
		changeFieldState($(this).attr('id'), $(this).prop('checked'));
	});
});
